import { render, staticRenderFns } from "./ReplicateOrderModal.vue?vue&type=template&id=cb835634"
import script from "./ReplicateOrderModal.vue?vue&type=script&lang=js"
export * from "./ReplicateOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports